module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"menu":{"myPage":"Top","editUser":"Edit User","message":"Message","help":"Help","logout":"Logout"}},"ja":{"menu":{"myPage":"トップ","editUser":"ユーザ情報編集","message":"メッセージ","help":"ヘルプ","logout":"ログアウト"}}}')
  delete Component.options._Ctor
}
